import 'BomdisoftComponents/account/auth-buttons/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';

export type AuthButtonProps = {
  href: string;
  label: string;
  className?: string;
  testId?: string;
};

export const SignInButton = ({ className, href, label, testId = 'sign-in-button' }: AuthButtonProps) => (
  <a className={joinClasses('bomdisoft-auth-buttons-sign-in', className)} data-testid={testId} href={href}>
    {label}
  </a>
);

export const SignUpButton = ({ className, href, label, testId = 'sign-up-button' }: AuthButtonProps) => (
  <a className={joinClasses('bomdisoft-auth-buttons-sign-up', className)} data-testid={testId} href={href}>
    {label}
  </a>
);
